import cx from 'classnames';
import * as React from 'react';

export interface CardBoxProps {
  className?: string;
  hasComponentLayout?: boolean;
  hasTable?: boolean;
  isHoverable?: boolean;
  footer?: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  elevation?: 'none' | 'sm' | 'md' | 'lg';
}

export const CardBox: React.FC<React.PropsWithChildren<CardBoxProps>> = ({
  className,
  hasComponentLayout = false,
  hasTable = false,
  isHoverable = false,
  children,
  footer,
  onClick,
  elevation = 'sm',
}) => {
  const elevationStyles = {
    none: '',
    sm: 'shadow-sm hover:shadow-md',
    md: 'shadow-md hover:shadow-lg',
    lg: 'shadow-lg hover:shadow-xl',
  };

  const cardContent = hasComponentLayout ? (
    children
  ) : (
    <>
      <div className={hasTable ? '' : 'flex-1'}>{children}</div>
      {footer && (
        <div className='mt-6 pt-4 border-t border-grey-100'>{footer}</div>
      )}
    </>
  );

  return (
    <div
      className={cx(
        'card',
        'bg-white',
        'flex flex-col',
        'rounded-xl',
        elevationStyles[elevation],
        hasComponentLayout ? '' : hasTable ? 'overflow-hidden' : 'p-6',
        (isHoverable || onClick) &&
          'hover:shadow-lg transition-all duration-300 cursor-pointer',
        !hasComponentLayout && !hasTable && 'transition-all duration-200',
        className,
      )}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {cardContent}
    </div>
  );
};
